import React from 'react'
import { Link } from 'react-router'
import { ImageList } from '../../components/ImageList'
import { injectIntl } from 'react-intl'
import { galleries } from '../../messages/galleries'
import { strings } from '../../messages/strings'

const gallery = galleries.MISCELLANEOUS 
const galleryPaths = gallery.paths
const galleryThumbs = gallery.thumbs

class Index extends React.Component {

  constructor() {
    super()
    this.state = { imageIndex: 1, pageIndex: 1, layout: 'landscape' }
  }

  _fire(index, layout='landscape') {
    if(layout === 'landscape' ) {
      this.setState({imageIndex: index, layout: 'landscape'})
    } else {
      this.setState({imageIndex: index, layout: 'portrait'})
    }
  }

  _buildThumbList() {
    const listItems = gallery.pages[this.state.pageIndex-1].map((item, i) => {
      return (<li key={i}><img src={`/assets/${galleryThumbs[this.state.pageIndex-1]}/${i+1}thumb${i+1}.jpg`} 
        onMouseOver={()=>this._fire(i+1, item.layout)}/></li>)
    })
    return (
      <ul className='thumb-list' >
        { listItems }
      </ul>
    )
  }

  render() {
    const pageIndex = this.state.pageIndex
    const layout = this.state.layout
    const { formatMessage } = this.props.intl
    return (
      <div
        style={{
          position: 'relative',
          borderLeft: '1px solid #CCCCFF',
          borderTop: '1px solid #CCCCFF',
          padding: 15,
          height: 690
        }}
      >
        
        <div style={{
            position: 'absolute',
            top: -24,
            right: 0,
            height: 24,
            width: 400,
            background: '#ccccff'}}>
          <span style={{width: '40%', textAlign: 'center', display: 'block', float: 'left', color: '#333366', fontWeight: 900, lineHeight: '26px'}}>
            {gallery.name}&nbsp;&nbsp;
          </span>
          <span style={{width: '50%', textAlign: 'center', display: 'block', float: 'left', lineHeight: '26px', fontSize: '12px'}}>
            <Link to='/contact/'>{formatMessage(strings.PURCHASE)}</Link>
          </span>
        </div>

        <div className={layout}>

          { this._buildThumbList() }

          <div style={{padding: '12px 17px 12px 17px'}}>
            <img className='image' src={`/assets/${galleryPaths[0]}/${this.state.imageIndex}.jpg`} />

          <div className='aside'>
            <div className='title'>{gallery.pages[this.state.pageIndex-1][this.state.imageIndex-1].name()}</div>
            <div className='details'>{gallery.pages[this.state.pageIndex-1][this.state.imageIndex-1].text()}</div>
          </div>

          </div>

        </div>

        <div style={{position: 'absolute', top: 390, left: -133, fontSize: 12}}> 
          <ImageList />
        </div>

      </div>
    )
  }
}

export default injectIntl(Index)



// WEBPACK FOOTER //
// ./images/miscellaneous-photos.js